import { CButton, CCard, CCardBody, CCol, CForm, CRow } from '@coreui/react'
import { DatePicker } from 'antd'
import React, { useEffect, useState } from 'react'
import BaseListing from 'src/BaseListings'
import WidgetDepartmentSelector from '../../widgets/Selectors/WidgetDepartmentSelector'
import WidgetSelector from 'src/widgets/Selectors/WidgetSelector'
import WidgetBranchMultiSelector from 'src/widgets/Multi-Selectors/WidgetBranchMultiSelector'
import { wtApiCall } from '../../helpers/commons/ApiWrapper'
import { lzNotifyErrorMessageFromResult } from '../../helpers/commons/notifications'
import { ApprovalStatusOptions } from 'src/helpers/commons/dropdownOptions'
import { useMasterDateTimeFormats } from 'src/helpers/commons/masterDateFormat'
import Loading from 'src/helpers/commons/loader'
import DetailedDataReportTable from '../EmployeeDetailedDataReport/DetailedDataReportTable'

const defaultCheckedList = ['id', 'full_name', 'gender', 'department_id', 'branch_id', 'from_date', 'to_date', 'approval_status']

export default function InternshipReport() {
  const Base = new BaseListing()
  const { formatDate } = useMasterDateTimeFormats()
  const [isLoading, setIsLoading] = useState(false)
  const [reportData, setReportData] = useState([])
  const [branches, setBranches] = useState([])
  const [departments, setDepartments] = useState([])
  const [selectedBranches, setSelectedBranches] = useState([])
  const [departmentId, setDepartmentId] = useState(0)
  const [departmentName, setDepartmentName] = useState('')
  const [approvalStatus, setApprovalStatus] = useState(0)
  const [dateRange, setDateRange] = useState([])
  const canView = Base.hasRights('View Internees Report')
  const canExport = Base.hasRights('Export Internees Report')

  const columns = [
    { title: 'ID', dataIndex: 'id', key: 'id', width: 70 },
    { title: 'Full Name', dataIndex: 'full_name', key: 'full_name', width: 160 },
    { title: 'Gender', dataIndex: 'gender', key: 'gender', width: 90 },
    { title: 'Department', key: 'department_id', width: 150, render: (record) => record.department?.name || '-' },
    { title: 'Branch', key: 'branch_id', width: 140, render: (record) => record.branch?.name || '-' },
    { title: 'Address', dataIndex: 'address', key: 'address', width: 220 },
    { title: 'City', dataIndex: 'city', key: 'city', width: 110 },
    { title: 'State', dataIndex: 'state', key: 'state', width: 110 },
    { title: 'Mobile Phone', dataIndex: 'mobile_phone', key: 'mobile_phone', width: 130 },
    { title: 'Home Phone', dataIndex: 'home_phone', key: 'home_phone', width: 130 },
    { title: 'Email', dataIndex: 'email', key: 'email', width: 200 },
    { title: 'CNIC', dataIndex: 'cnic', key: 'cnic', width: 150 },
    { title: 'University', dataIndex: 'university_name', key: 'university_name', width: 180 },
    { title: 'CGPA', dataIndex: 'cgpa', key: 'cgpa', width: 80 },
    { title: 'Major Subjects', dataIndex: 'major_subjects', key: 'major_subjects', width: 200 },
    { title: 'Facilitated Through', dataIndex: 'internship_facilitied_through', key: 'internship_facilitied_through', width: 180 },
    { title: 'Father Name', dataIndex: 'father_name', key: 'father_name', width: 160 },
    { title: 'Father Employer', dataIndex: 'father_employer', key: 'father_employer', width: 160 },
    { title: 'From Date', dataIndex: 'from_date', key: 'from_date', width: 120, render: (text) => formatDate(text), isDate: true },
    { title: 'To Date', dataIndex: 'to_date', key: 'to_date', width: 120, render: (text) => formatDate(text), isDate: true },
    { title: 'Approval Status', dataIndex: 'approval_status', key: 'approval_status', width: 130, render: (text) => ({ 0: 'Pending', 1: 'Approved', 2: 'Rejected' })[text] || '-' },
    { title: 'Emergency Contact', key: 'emergency_first_name', width: 180, render: (record) => `${record.emergency_first_name || ''} ${record.emergency_last_name || ''}`.trim() || '-' },
    { title: 'Emergency Phone', dataIndex: 'emergency_primary_phone', key: 'emergency_primary_phone', width: 140 },
    { title: 'Relationship', dataIndex: 'relationship_with_employee', key: 'relationship_with_employee', width: 130 },
  ]

  const getReportData = () => {
    setIsLoading(true)
    wtApiCall('reports/internship_report', {
      branch_ids: selectedBranches.map(({ value }) => value),
      department_id: departmentId,
      approval_status: approvalStatus,
      from_date: dateRange[0]?.format('YYYY-MM-DD') || '',
      to_date: dateRange[1]?.format('YYYY-MM-DD') || '',
    }, 'get', (response) => {
      setReportData(response.data)
      setIsLoading(false)
    }, (error) => {
      setIsLoading(false)
      lzNotifyErrorMessageFromResult(error)
    })
  }

  useEffect(() => {
    if (canView) Base.dropdownData('branches,departments', {}, [setBranches, setDepartments], 1)
  }, [canView])

  return (
    <div style={{ padding: '2%' }}>
      {!canView ? <center style={{ fontSize: '19px', fontWeight: 'bold' }}>You do not have permission to view Internees Report.</center> : <>
      <center><h4>Internees Report</h4></center>
      <CCard className="card-dark">
        <CCardBody style={{ backgroundColor: '#f7f9fa' }}>
          <CForm>
            <CRow className="g-3" style={{ alignItems: 'end' }}>
              <CCol md={3}><div className="d-flex flex-column gap-1"><label style={{ minHeight: 24 }}>Date Range</label><DatePicker.RangePicker value={dateRange} onChange={(value) => setDateRange(value || [])} style={{ width: '100%', height: 35 }} /></div></CCol>
              <CCol md={2}><div className="d-flex flex-column gap-1"><label style={{ minHeight: 24 }}>Department</label><WidgetDepartmentSelector departments={departments} displayValue={departmentName} value={departmentId} placeholder="Select Department" onChange={(value) => { setDepartmentId(value.value); setDepartmentName(value.label) }} /></div></CCol>
              <CCol md={3}><div className="d-flex flex-column gap-1"><label style={{ minHeight: 24 }}>Branch</label><WidgetBranchMultiSelector Branches={branches} value={selectedBranches} onChange={setSelectedBranches} /></div></CCol>
              <CCol md={2}><div className="d-flex flex-column gap-1"><label style={{ minHeight: 24 }}>Approval Status</label><WidgetSelector options={ApprovalStatusOptions} selectedValue={approvalStatus} placeHolder="Please Select" onChange={(value) => setApprovalStatus(value.value)} /></div></CCol>
              <CCol md={2}><CButton color="primary" onClick={getReportData} style={{ width: 80, height: 35 }}>Search</CButton></CCol>
            </CRow>
          </CForm>
        </CCardBody>
      </CCard>
      <br />
      {isLoading ? Loading : reportData.length > 0 ? <DetailedDataReportTable reportData={reportData} columns={columns} defaultCheckedList={defaultCheckedList} canExport={canExport} tableScrollX={3200} /> : <center style={{ fontSize: '19px', fontWeight: 'bold' }}>No record to show...</center>}
      </>}
    </div>
  )
}
